import { IUserBody } from "./accountTypes";
import { ICompany } from "./companyTypes";

export interface IUseMeContext {
  me: null | ICompanyUser;
  role: null | string;
  switchUser: (id: string) => void;
  isLoading: boolean;
  isError: boolean;
  isAdmin: boolean;
  selectedCompany: any;
  isCompanyRoot: boolean;
  permissions: TAdminPermission[];
  isCompanyAdmin: boolean;
  updateMyAccount: (
    userDetails: IUserBody,
    callback?: (res: any) => void
  ) => void;
  isRoot: boolean;
  isVip: boolean;
}

export interface IFields {
  email: string;
  name: string;
}

export interface ISelectedCompany {
  id: string;
  permissions: TCompanyUserPermission[];
}

export interface ICompanyUserRequest {
  email: string;
  name: string;
  companies: ISelectedCompany[];
}

export interface ICompanyUser {
  id: string;
  email: string;
  name: string;
  phone: string;
  role: string;
  permissions: TAdminPermission[];
  creationDate: string;
  language: string;
  cpiCompliance: boolean;
  allowMarketingCommunications: boolean;
  companyEmails: string[];
  selectedCompanyId: string;
  confirmationRequired: boolean;
  companies: ICompany[];
  isVip: boolean;
}

export type TAdminPermission =
  | "viewAnnouncements"
  | "editAnnouncements"
  | "viewRules"
  | "editRules"
  | "viewContent"
  | "editContent"
  | "viewAdmins"
  | "editAdmins"
  | "imitateClient"
  | "editTurnovers";

export type TCompanyUserPermission =
  | "editTurnovers"
  | "viewContracts"
  | "viewCPI"
  | "viewTurnovers"
  | "createIncidents"
  | "viewIncidents"
  | "editIncidents";

export enum AdminPermissions {
  viewAnnouncements = "viewAnnouncements",
  editAnnouncements = "editAnnouncements",
  viewRules = "viewRules",
  editRules = "editRules",
  viewContent = "viewContent",
  editContent = "editContent",
  viewAdmins = "viewAdmins",
  editAdmins = "editAdmins",
  imitateClient = "imitateClient",
  editTurnovers = "editTurnovers",
}

export enum CompanyUserPermissions {
  invoices = "invoices",
  requests = "requests",
  incidents = "incidents",
  contracts = "contracts",
  turnovers = "turnovers",
  reports = "reports",
  visitorsReports = "visitorsReports",
  contacts = "contacts",
}
